import $ from 'jquery'
import { Message } from 'element-ui';
import { downloadPath } from '@/api/onlineEdit.api'

function schemeReplace(url = '') {
  return url.replace(/http[s]?:\/\//, '//');
}

export async function singleDownload (arr, url) {
  if (!arr || arr.length === 0) {
    return
  }
  let index = 0
  //  判断请求路径是否有效以及后续操作
  const effective = function (downloadUrl, name) {
    const eleLink = document.createElement('a')
    eleLink.style.display = 'none'
    eleLink.download = name
    eleLink.href = schemeReplace(downloadUrl)
    document.body.appendChild(eleLink)
    eleLink.click()
    setTimeout(() => {
      document.body.removeChild(eleLink)
      // 循环下载
      fn()
    }, 1000)
  }
  let fn = async function () {
    if (index <= arr.length - 1) {
      const { id } = arr[index]
      const { name } = arr[index]
      if (id) {
        let downloadUrl = ''
        if (arr[0].flag === 'preview') {
          downloadUrl = arr[0].url
        } else if (arr[0].source === 8) {
          downloadUrl = await getOssDownloadPath(arr[index], url)
          const eleLink = document.createElement('a')
          eleLink.style.display = 'none'
          eleLink.download = name
          eleLink.href = schemeReplace(downloadUrl)
          document.body.appendChild(eleLink)
          eleLink.click()
          document.body.removeChild(eleLink)
        } else {
          downloadUrl = await getOssDownloadPath(arr[index], url)
        }
        if ($('#download_iframe')) {
          effective(downloadUrl, name)
        } else {
          $('#download_iframe').remove()
          effective(downloadUrl, name)
        }
      }
      index++
    }
  }
  fn()
}

export async function getOssDownloadPath (fileData, url) {
  let sendUrl = ''
  if (url === '/rfs/downloadOuterNetByDocId') {
    sendUrl = `/rfs/downloadOuterNetByDocId?docId=${fileData.id}`
  } else if (+fileData.source === 8) {
    sendUrl = fileData.url
    if (fileData.setSource && fileData.setSource) {
      fileData.id = fileData.docId
    }
    let downloadPathParams = {
      data: fileData,
      url: sendUrl
    }
    return downloadPath(downloadPathParams).then(
      (response) => {
        if (response.code !== 0) {
          Message({
            type: 'warning',
            message: response.msg
          })
          return
        }
        return schemeReplace(response.data.url)
      },
      (err) => {
        Message({
          type: 'error',
          message: err.msg || '网络异常，请刷新重试'
        })
      }
    )
  } else {
    sendUrl = `/rfs/downloadOuterNet?docId=${fileData.docId}&rfsId=${fileData.id}`
  }
  let getOssDownloadParams = {
    url: sendUrl
  }
  return downloadPath(getOssDownloadParams).then((response) => {
    if (response.code !== 0) {
      Message({
        type: 'warning',
        message: response.msg
      })
      return
    }
    return schemeReplace(response.data.url)
  },
  (err) => {
    Message({
      type: 'error',
      message: err.msg || '网络异常，请刷新重试'
    })
  }
  )
}



// WEBPACK FOOTER //
// ./src/utils/download.js